export const iconFontAwesomeMedicalHealthStethoscope = (
	<i className="fa-solid fa-stethoscope"></i>
);
